import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material/styles'

export const useStyles = makeStyles()((theme: Theme) => ({
  row: {
    display: 'flex',
    gap: 4,
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: 6,
    minWidth: 0,
    maxWidth: 520,
  },
  attachments: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
    justifyContent: 'flex-end',
    maxWidth: '100%',
  },
  pill: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    maxWidth: '100%',
    padding: '6px 10px',
    borderRadius: 16,
    backgroundColor: theme.palette.text.white,
    border: `1px solid ${theme.palette.stages.hovered}`,
    textDecoration: 'none',
    cursor: 'pointer',
    color: theme.palette.labraText.tertiary,
    fontFamily: 'Inter, sans-serif',
    fontSize: 12,
    lineHeight: '16px',
    transition: 'background-color 120ms',
    '& svg': {
      fontSize: 12,
      flexShrink: 0,
      color: theme.palette.labraText.description,
    },
    '&:hover': {
      backgroundColor: theme.palette.labraChat.hoverBg,
    },
  },
  pillName: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: 200,
  },
  bubble: {
    backgroundColor: theme.palette.text.white,
    border: `1px solid ${theme.palette.stages.hovered}`,
    borderRadius: 8,
    padding: '12px',
    maxWidth: 520,
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.tertiary,
    fontFamily: 'Inter, sans-serif',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
  actionRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  actionButton: {
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    fontSize: 12,
    lineHeight: 1,
    color: theme.palette.labraText.description,
    '&:hover': {
      color: theme.palette.labraText.tertiary,
    },
    // Saved is a resting state, not a dead control: it reads darker, not faded.
    '&:disabled': {
      cursor: 'default',
      color: theme.palette.labraText.tertiary,
    },
  },
  confirmedIcon: {
    color: theme.palette.syncStatus.success,
  },
  actionDivider: {
    width: 1,
    height: theme.spacing(2),
    backgroundColor: theme.palette.stages.hovered,
  },
  time: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    fontFamily: 'Inter, sans-serif',
    fontSize: 11,
    fontWeight: 500,
    lineHeight: '14px',
    color: theme.palette.labraText.description,
    paddingRight: 2,
  },
  avatar: {
    width: 24,
    height: 24,
    borderRadius: '50%',
    backgroundColor: theme.palette.labraChat.highlight,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    fontFamily: 'Inter, sans-serif',
    fontWeight: 500,
    fontSize: 11,
    letterSpacing: '0.5px',
    color: theme.palette.black.dark,
  },
}))
